// TODO 이모티콘 메뉴 배경 이미지 미리 불러오기
NP.emoticonLayer = ( function( $, util, MsgPreview, EmoticonData, StickerData ) {

	var menuTemplate = util.getTemplate( '<li class="#{= it.cName }#"#{? it.groupId }# data-gname="#{= it.cName }#" data-gid="#{= it.groupId }#"#{?}#><a href="#">#{= it.name }#</a></li>' ),
		topNaviTimer = null,
		$el = null,
		$closeButton = null,
		$pane = null,
		$emoticonList = null,
		$stickerList = null,
		$topNavi = null,
		$bottomNaviWrap = null,
		$overflow = null,
		$bottomNavi = null,
		$buttonWrap = null,
		$prevButton = null,
		$nextButton = null,

		selectedMenu = null,
		bottomNaviWidth = null,
		bottomNaviListWidth = null,
		buttonPrevWidth = null,
		buttonNextWidth = null,

		emoticonPageSize = 27,
		stickerPageSize = 10,
		MsgForm  = null,
		caretPosition = 0,
		list = [];

	for( var i = 0; NP.StickerData.list[ i ]; i += 1 ){
		var group = NP.StickerData.list[ i ];
		var menu = $( menuTemplate({
			cName : group.cls,
			name : group.tit,
			groupId : group.gid
		}));
		
		list.push( menu );
	};
	
	// 초기화
	function init( parentNode ) {
		caretPosition = 0;
		
		if( MsgForm ){
			hide();
			MsgForm = null;
		};
		
		MsgForm = parentNode;
		
		//메시지 입력시 커서 위치 저장
		MsgForm && MsgForm.find( '.comment input' ).on( 'keyup', function(){
			if( !MsgForm ) caretPosition = 0;
			var pane = MsgForm.find( '.comment input' );
			caretPosition = NP.Util.getCaretPosition( pane );
		});
		
		if ( $el ) {
			parentNode.append( $el );
			MsgPreview && MsgPreview.hide();
			show();
			return;
		}
		
		render();
		eventBinding();
		MsgPreview.init();
		show();
	}
	
	// 마크업 생성
	function render() {
		$el = $( '<div class="wrapEmoticon emoticon-select animated" style="display:none"></div>' );
		$closeButton = $( '<a class="btnClose btn is-close-emoticon">닫기</a>' );
		$pane = $( '<div class="theme-list animated">' );
		$emoticonList = $( '<ul class="listEmoticon emoticon-list">' );
		$stickerList = $( '<ul class="listSticker emoticon-list style="display:none;">' );
		$topNavi = $( '<nav class="navList"></nav>' );
		$bottomNaviWrap = $( '<div class="wrapTheme theme-nav">' );
		$overflow = $( '<div class="wrapListTheme overflow-list animated fadeIn">' );
		$bottomNavi = $( '<ul class="listTheme theme-nav-list">' );
		$buttonWrap = $( '<nav class="btn-group"></nav>' );
		$prevButton = $( '<a class="btnPrevTheme btn is-theme-prev"><span>이전목록</span></a>' );
		$nextButton = $( '<a class="btnNextTheme btn is-theme-next"><span>다음목록</span></a>' );

		$overflow.append( $bottomNavi );
		$pane.append( $emoticonList, $stickerList );
		$buttonWrap.append( $prevButton, $nextButton );
		$bottomNaviWrap.append( $overflow, $buttonWrap );
		$el.append( $topNavi, $pane, $bottomNaviWrap, $closeButton );
		MsgForm.append( $el );
		
		$( list ).each(function() {
			$bottomNavi.append( $( this ) );
		});		
		
	}

	// 이벤트 바인딩
	function eventBinding() {
		// 이모티콘 레이어 닫기
		$closeButton.click(function() {
			hide();
		});

		// 이전 버튼 클릭 시 스크롤
		$prevButton.click(function() {
			$bottomNavi.animate({
				left : 0
			}, 200);
		});
		
		// 다음 버튼 클릭 시 스크롤
		$nextButton.click(function() {
			var scrollTerm = $bottomNavi.width() - $el.width() - $prevButton.width() / 2;
			$bottomNavi.animate({
				left : -scrollTerm
			}, 200);
		});

		//커서 위치 저장
		$( 'body' ).on( 'click', function(){
			if( !MsgForm ) caretPosition = 0;
			var pane = MsgForm.find( '.comment input' );
			caretPosition = NP.Util.getCaretPosition( pane );
		});

		// 바닥 네비 선택
		$( list ).each(function() {
			$( this ).click(function( e ) {
				e.preventDefault();
				var $clicked = $( this );

				// 같은 메뉴 반복 클릭 시 무시
				if ( selectedMenu === this ) {
					return;
				}

				selectedMenu = this;

				$clicked.siblings().removeClass( 'on' );
				$clicked.siblings().find( 'a' ).removeClass( 'on' );
				
				$clicked.addClass( 'on' );
				$clicked.find( 'a' ).addClass( 'on' );

				$pane.empty();

				if ( $clicked.hasClass( 'emoticon' ) ) { // 이모티콘
					setNavi( Math.ceil( EmoticonData.length / emoticonPageSize ) );
					$topNavi.removeClass( 'sticker' ).addClass( 'emoticon' );
					topNaviSelect( $topNavi.find( 'a:first' ) );
				} else { // 스티커
					setNavi( Math.ceil( 
						StickerData[ $clicked.data( 'gid' ) - 1 ].length / stickerPageSize ), true );
					$topNavi.removeClass( 'emoticon' ).addClass( 'sticker' );
					topNaviSelect( $topNavi.find( 'a:first' ), true );
				}
			});
		});

		// 상단 네비 선택
		function topNaviSelect( context ) {
			var $clicked = $( context ),
				$parent = $clicked.parent();

			$parent.find( 'a' ).removeClass( 'on' );
			$clicked.addClass( 'on' );
			$pane.find( '.emoticon-list' ).remove();
			
			$pane.append( setPage( $clicked.data( 'page' ) ) );
		};
		
		$el.on( 'click mouseenter', '.navList a', function( e ) {
			e.preventDefault();

			var context = this;

			if ( e.type === 'mouseenter' ) {
				clearTimeout( topNaviTimer );
				topNaviTimer = setTimeout(function() {
					topNaviSelect( context );
				}, 100);

				return;
			}

			topNaviSelect( context );
		});
		$el.on( 'mouseleave', '.navList a', function() {
			clearTimeout( topNaviTimer );
		});

		// 이모티콘 선택
		$pane.on( 'click', '.emoticon-list li.emoticon a', function( e ) {
			e.preventDefault();
			
			var input = MsgForm.find( '.comment input' );
			var	img = $( this ).find( 'img' ).attr( 'alt' );
			var	caret = caretPosition;
			
			input.focus();
			if( caret ){
				var pre = input.val().substring( 0, caret ),
					end = input.val().substring( caret );
				input.val( pre + img + end );
				caretPosition = caret + img.length;
			}else{
				var value = input.val();
				input.val( value + img );
			}
		});
		
		// 스티커 선택
		$pane.on( 'click', '.emoticon-list li.sticker a', function( e ) {
			e.preventDefault();
			var img = $( this ).find( 'img' );
			$el.prev( '.wrap_form' ).append( MsgPreview.render( {'animation': img.attr( 'src' ), 'name': img.attr( 'alt' )} ) );
			MsgPreview.show();
			MsgForm.find( '.comment input' ).focus();
		});
	};

	// 상단 네비 세팅
	function setNavi( pageCount ) {
		$topNavi.empty();
		
		for ( var i = 0; i < pageCount; i += 1 ) {
			$topNavi.append( '<a href="#" data-page="'+ i +'"><span>' + i + '</span></a>' );
		}
	};

	// 페이징 세팅
	function setPage( page ) {
		if( $topNavi.hasClass( 'sticker' ) ){//스티커 페이징
			var cache = $stickerList.clone(),
				gid = $( selectedMenu ).data( 'gid' ),
				gName = $( selectedMenu ).data( 'gname' );
			
			for ( var i = page * stickerPageSize, len = page * stickerPageSize + stickerPageSize ; i < len; i += 1 ) {
				var sticker = StickerData[ gid - 1 ][ i ];
				
				if( !sticker ) break;
				
				var	name = sticker.name,
					sid = ( sticker.sid + 1 ),
					width = sticker.width,
					height = sticker.height,
					useSid = ( sid + '' ).slice( ( sid + '' ).length - 2 );

				cache.append( '<li class="sticker"><a href="#"><img src="' + NP.STATIC_URL + 'resource/sticker/image/' + gName + '/' + useSid + '/thumb.png" alt="{{' + name + '}}"></a></li>' );
			}			
		}else{//이모티콘 페이징
			var cache = $emoticonList.clone();
			
			for ( var i = page * emoticonPageSize, len = page * emoticonPageSize + emoticonPageSize ; i < len; i += 1 ) {
				var emoticon = EmoticonData[ i ];
				
				if( !emoticon ) break;
				
				cache.append( '<li class="emoticon"><a href="#"><img src="' + NP.STATIC_URL + 'ncm/res/ncm_emoticon_72/' + emoticon.url + '.png" alt="(' + emoticon.name[ 0 ] + ')"></a></li>' );
			}
		};

		return cache;
	}

	// 이모티콘 레이어 보이기
	function show() {
		$el.addClass( 'fadeIn' ).show();

		setTimeout(function() {
			!selectedMenu && $bottomNavi.children().first().trigger( 'click' ); // 최초에는 이모티콘 선택
			$bottomNavi.find( '.on' ).find( 'a' ).focus();
		}, 1 );
	}

	// 이모티콘 레이어 감추기
	function hide() {
		if ( !$el || ( $el && !$el.is( ':visible' ) ) ) {
			return;
		}

		caretPosition = 0;
		$el.hide().removeClass( 'fadeIn' );
		MsgPreview.hide();
	}

	//뷰에 이모티콘 변환 노출
	function renderEmoticion( text, forceSmallType ) {
		
		text = renderSticker( text );
		
		if ( !text.match( /\(.+\)/g ) ) {
			return text
		}

		for( var item = 0, len = EmoticonData.length; len > item; item += 1 ){
			var name = EmoticonData[ item ].name[ 0 ],
				url = EmoticonData[ item ].url;
			
			var text = text.replace( new RegExp( '\\((' + name + ')\\)', 'g' ), function( match ) {
				return '<img class="emoticon emo" src="' + NP.STATIC_URL + 'ncm/res/ncm_emoticon_24/' + url + '.png" alt="' + match + '" title="' + match + '" />';
			});
		}

		return  text;
	};
	
	//뷰에 스티커 변환 노출
	function renderSticker( text ) {
		if ( !text.match( /\{\{.+\}\}/g ) ) {
			return text;
		}

		var list = NP.StickerData.list;
		for( var i = 1, len = StickerData.length; len >= i; i += 1 ){
			for( var j = 0, jlen = StickerData[ i - 1 ].length; jlen > j; j += 1 ){
				var sticker = StickerData[ i - 1 ][ j ],
					name = sticker.name,
					groupName = list[ i ].cls,
					sid = ( sticker.sid + 1 ),
					useSid = ( sid + '' ).slice( ( sid + '' ).length - 2 );	

				
				var text = text.replace(  new RegExp('\{\{' + name + '\}\}', 'g') , function( match ) {
					var img = '<img src="' + NP.STATIC_URL + '/resource/sticker/image/' + groupName + '/' + useSid + '/sticker.gif" alt="{{' + name + '}}"></a>';
					return '<div class="wrapSticker"><div class="sticker">'+ img +'</div></div>';
				});
			}
		}
		return  text;
	};		

	// API
	return {
		renderEmoticion: renderEmoticion,
		renderSticker: renderSticker,
		init : init,
		hide :hide
	};
}( jQuery, NP.Util, NP.MsgPreview, NP.EmoticonData, NP.StickerData ));
